module.exports = __webpack_public_path__ + "static/media/head-sketches.83b5de57.png";